export var SkillType;
(function (SkillType) {
    SkillType[SkillType["SOFT_SKILL"] = 10] = "SOFT_SKILL";
    SkillType[SkillType["PRODUCT_SKILL"] = 20] = "PRODUCT_SKILL";
})(SkillType || (SkillType = {}));
//# sourceMappingURL=skill.i.js.map